
import {FrontWebPodcastEpisodeModel} from "../../../generated";
import {usePlayOrStop} from "../../Player";

import RadioCss from "../Style.module.scss";

import { RouteLink } from "../../RouteLink";
import  routes  from "../../../utils/routes"
import { slugifyText } from "../../../utils/slugifyText";
import { LogoEpisode } from "../Image/LogoEpisode";
import { EpisodeSlider } from "./EpisodeSlider";
import { useRadio } from "../../../contexts/useRadio";

import playpodcastsvg from "../../../static/playbuttonpodcast.svg";
import playingpodcastsvg from "../../../static/playingpodcast.svg";
import loadingpodcastsvg from "../../../static/loadingpodcast.svg";


export const EpisodeRow = (props: {
    className?: string,
    episode: FrontWebPodcastEpisodeModel,
    smallVersion?: boolean,
    asHref?: boolean,
    asMain?: boolean
}) => {

    const asHref = props.asHref === undefined || props.asHref;
    const date = new Date(props.episode.pubDate);
    const { play, isPlaying, isLoading } = usePlayOrStop(props.episode);
    const hasRadio = useRadio();
    const todayDate = new Date();

    const today = date.getMonth() === todayDate.getMonth() && date.getDate() === todayDate.getDate() && date.getFullYear() === todayDate.getFullYear() ? <><span className={RadioCss.today}>DNES</span>&nbsp;&nbsp;&nbsp;</>: false;

    let icon = playpodcastsvg;
    if (isPlaying()) {
        icon = playingpodcastsvg;
    } else if (isLoading()) {
        icon = loadingpodcastsvg;
    }
    const content = <>
        <LogoEpisode onPlay={play} src={props.episode.image} alt={props.episode.name} className={`align-self-top ${RadioCss.episodeRight}`} smallVersion={props.smallVersion} />
        <div className={`align-self-top ${RadioCss.episodeText} d-fill`}>
            {today}<span className={RadioCss.day}>{date.getDate()}. {date.getMonth()+1}. {date.getFullYear()}</span>
            {asHref ? <strong className={RadioCss.episodeHeader}>{props.episode.name}</strong> : <br/>}
            {!props.smallVersion ? (props.episode.description ?? "") : false}
            <div className={`d-flex ${RadioCss.playPodcast}`}>
                {props.smallVersion ? false :
                    <button className={"button-as-href"} onClick={e=>{
                        e.preventDefault();
                        play();
                    }}>
                        <img alt={""}  width={32} height={32} src={icon} className={"align-self-center"}/>
                    </button>}
                {!props.asMain ?
                    <EpisodeSlider  asHref={props.asHref} episode={props.episode} />
                    :
                    <EpisodeSlider className={RadioCss.hideOnSmallDisplay} asHref={props.asHref} episode={props.episode} />}
            </div>
        </div>

    </>

    const episode = props.episode;
    const url = hasRadio ? routes.radio_program_detail_episode(hasRadio.slug, episode.programSlug, `${episode.id}`, slugifyText(episode.name)) : routes.program_detail_episode(episode.programSlug, `${episode.id}`, slugifyText(episode.name));


    return asHref ? (<RouteLink  className={`${props.className ?? ""} ${RadioCss.LinkRow} d-flex flex-row align-items-start `} to={url}>
        {content}
    </RouteLink>) : ( <>
        <div className={`${props.className ?? ""} ${RadioCss.LinkRow} d-flex flex-row align-items-start `}>{content}</div>
        {props.asMain ?
            <div className={`${props.className ?? ""} ${RadioCss.LinkRow} d-flex flex-row align-items-start mt-4`}>
                <EpisodeSlider withAddRemoveSeconds={props.asMain} className={`${RadioCss.showOnSmallDisplay}`}  asHref={props.asHref} episode={props.episode} />
            </div>
        : null }
    </>);


}
